import { Stack } from '@mui/material'
import { Link } from 'react-router-dom'
// import { logo } from '../utils/constants'
import SearchBar from './SearchBar'
// import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
// import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SlowMotionVideoIcon from '@mui/icons-material/SlowMotionVideo';

const Navbar = () => (
    <Stack 
    direction='row' 
    alignItems='center' 
    p={2} 
    sx={{ position: 'sticky', background:'#061312', top: 0, justifyContent:'space-between' }}>
      <Link to='/' style={{ display:'flex', alignItems:'center' }}>
        {/* <img src={logo} alt='logo' height={45} sx={{ background: 'white' }}/> */}
        {/* <SubscriptionsIcon sx={{ color: 'white', fontSize: '40px', background: '#007579', padding: '6px', borderRadius: '50%' }} /> */}
        {/* <OndemandVideoIcon sx={{ color: 'white', fontSize: '35px', background: '#007579', padding: '4px', borderTopRightRadius: '15px', borderBottomLeftRadius: '15px' }} /> */}
        <SlowMotionVideoIcon sx={{ color: 'white', fontSize: '40px', background: '#007579', padding: '3px', borderRadius: '50%' }} />
      </Link>
      <SearchBar />
    </Stack>
)

export default Navbar